import * as React from 'react';
import Full from './Full';
import Compact from './Compact';
import { useMatchLargeViewport } from '@avensia/excite';

export default function Header() {
  const isLarge = useMatchLargeViewport();
  return isLarge ? <Full /> : <Compact />;
}
